import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Select from './Select';

import {
  inputPropTypes,
  metaPropTypes,
  inputDefaultProps,
  metaDefaultProps,
} from '../../forms/input/InputPropTypes';
import { clearPositions, getPositions } from '../../../../actions/hcm/Position';

const HcmPositionSelect = ({
  dispatchGetPositions,
  dispatchClearPositions,
  positions,
  isLoading,
  isMulti,
  input,
  meta,
  ...rest
}) => {
  useLayoutEffect(() => {
    dispatchGetPositions();

    return () => {
      dispatchClearPositions();
    };
  }, []);

  return (
    <Select
      options={positions}
      isLoading={isLoading}
      isMulti={isMulti}
      input={input}
      meta={meta}
      {...rest}
    />
  );
};

HcmPositionSelect.propTypes = {
  dispatchGetPositions: PropTypes.func.isRequired,
  dispatchClearPositions: PropTypes.func.isRequired,
  isMulti: PropTypes.bool,
  input: inputPropTypes,
  positions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.number,
    }),
  ),
  meta: metaPropTypes,
  isLoading: PropTypes.bool,
  isDisabled: PropTypes.bool,
};

HcmPositionSelect.defaultProps = {
  input: inputDefaultProps,
  meta: metaDefaultProps,
  isLoading: false,
  isMulti: false,
  positions: [],
  isDisabled: false,
};

const mapStateToProps = ({ HcmUnit }) => ({
  positions: HcmUnit.Position.getIn(['content', 'content']).map((position) => ({
    value: position.get('id'),
    label: position.get('name'),
  })),
  isLoading: HcmUnit.Position.getIn(['content', 'loading']),
});

const mapDispatchToProps = {
  dispatchGetPositions: getPositions,
  dispatchClearPositions: clearPositions,
};

export default connect(mapStateToProps, mapDispatchToProps)(HcmPositionSelect);
